import type { ReactNode } from 'react';
import Overview from '@/app/Crawl/components/pages/details/Overview';
import Density from '@/app/Crawl/components/pages/details/Density';
import OutlinkInternal from '@/app/Crawl/components/pages/details/OutlinkInternal';
import OutlinkExternal from '@/app/Crawl/components/pages/details/OutlinkExternal';
import Img from '@/app/Crawl/components/pages/details/Img';
import Css from '@/app/Crawl/components/pages/details/Css';
import Js from '@/app/Crawl/components/pages/details/Js';
import Issues from '@/app/Crawl/components/pages/details/Issues';
import AssetsAll from '@/app/Crawl/components/pages/details/AssetsAll';
import LinksAll from '@/app/Crawl/components/pages/details/LinksAll';

interface DetailTab {
  tab: string;
  title: string;
  cellRenderer: ReactNode;
}

export const detailTabsConfig: Record<string, DetailTab> = {
  overview: {
    tab: 'overview',
    title: 'نمای کلی',
    cellRenderer: <Overview />
  },
  density: {
    tab: 'density',
    title: 'چگالی',
    cellRenderer: <Density />
  },
  issues: {
    tab: 'issues',
    title: 'مورد',
    cellRenderer: <Issues />
  },
  // inlink: {
  //   tab: 'inlink',
  //   title: 'صفحه ارجاع',
  //   cellRenderer: <Inlink />
  // },
  outlink_internal: {
    tab: 'outlink_internal',
    title: 'پیوند داخلی',
    cellRenderer: <OutlinkInternal />
  },
  outlink_external: {
    tab: 'outlink_external',
    title: 'پیوند خارجی',
    cellRenderer: <OutlinkExternal />
  },
  image: {
    tab: 'image',
    title: 'تصاویر',
    cellRenderer: <Img />
  },
  css: {
    tab: 'css',
    title: 'css',
    cellRenderer: <Css />
  },
  js: {
    tab: 'js',
    title: 'js',
    cellRenderer: <Js />
  },
  assets_all: {
    tab: 'assets_all',
    title: 'صفحه ارجاع',
    cellRenderer: <AssetsAll />
  },
  links: {
    tab: 'links',
    title: 'صفحه ارجاع',
    cellRenderer: <LinksAll />
  }
};
